import Slider from './components/Slider';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'slider',
  pluginComponent: Slider,
});
